import React, { useState } from 'react';

import { PrimaryPlusIconButton } from 'src/components';
import { useAccessGuard } from 'src/components/auth';
import { Apollo } from 'src/gql/generated';

import { NewPartyDialog } from './NewPartyDialog';

interface NewPartyButtonProps extends React.HTMLAttributes<HTMLElement> {
  disabled?: boolean;
}

export function NewPartyButton({ className, disabled }: NewPartyButtonProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const handleOpen = useAccessGuard({
    callback: () => setOpen(true),
    minRole: Apollo.OrgRole.Basic,
  });

  return (
    <>
      <PrimaryPlusIconButton
        className={className}
        disabled={disabled}
        tooltip="New Party"
        onClick={handleOpen}
      />
      <NewPartyDialog handleClose={() => setOpen(false)} open={open} />
    </>
  );
}
